import { render, staticRenderFns } from "./ModalTaulaResultatsEnquesta.vue?vue&type=template&id=465ec12a&scoped=true&"
import script from "./ModalTaulaResultatsEnquesta.vue?vue&type=script&lang=js&"
export * from "./ModalTaulaResultatsEnquesta.vue?vue&type=script&lang=js&"
import style0 from "./ModalTaulaResultatsEnquesta.vue?vue&type=style&index=0&id=465ec12a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ec12a",
  null
  
)

export default component.exports